
export class User {
    id: string;
    email: string;
    groups: string[] = [];
    loggedIn: boolean;
    admin: boolean;

    constructor(data?) {
        if (data) {
            this.id = data.id;
            this.email = data.attributes.email;
        }
    }

    clear() {
        this.id = '';
        this.email = '';
        this.loggedIn = false;
        this.admin = false;
    }
}
